// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__LqxEj","signatureBlock":"Footer_signatureBlock__1K3mU","signature":"Footer_signature__3Vg-a"};